import {host} from "../redux/api/url.js"
import defaultLogo from '../../assets/images/ic_empty_image.png'

export function generateMediaUrl(path, forCopy = false) {
    if (forCopy) {
        return `${host}/files${path}`
    }
    return path ? `${host}/images${path}` : defaultLogo;
}
